import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Kartın üst şeridinin rengi (KSKLC Takip'teki gradyan çizgi). */
export type KartRengi =
  | 'indigo'
  | 'menekse'
  | 'turkuaz'
  | 'yesil'
  | 'amber'
  | 'gul'
  | 'okyanus'
  | 'bakir';

/**
 * §19.2 — Kart.
 *
 * 28 Eyl 2026: sahibin KSKLC Takip uygulamasının kutu stili — daha yuvarlak
 * köşe, yumuşak gölge, ince kenarlık. `renk` verilirse üstte gradyan şerit
 * çıkıyor (ana sayfa kutuları). Tüm sayfalar bu bileşeni kullandığı için
 * görünüm tek yerden değişiyor.
 */
export function Card({
  className,
  renk,
  ...props
}: HTMLAttributes<HTMLDivElement> & { renk?: KartRengi }) {
  return (
    <div
      data-renk={renk}
      className={cn(
        'rounded-[var(--radius-lg)] border border-border bg-bg-elevated shadow-[var(--shadow-sm)]',
        renk !== undefined && 'serit',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({
  title,
  description,
  action,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-start justify-between gap-4 border-b border-border px-5 pb-3.5 pt-4',
        className,
      )}
    >
      <div className="min-w-0 space-y-1">
        <h2 className="text-[0.9375rem] font-semibold tracking-[-0.01em] text-fg">{title}</h2>
        {description && <p className="text-xs leading-relaxed text-fg-muted">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-5', className)} {...props} />;
}
